import {
  Component,
  createEffect,
  ParentComponent,
  ParentProps,
  Show,
} from 'solid-js';
import { useAuth } from '../TIDProvider/useAuth';

interface AuthenticationGuardProps extends ParentProps {
  loader?: Component;
}

/**
 * Renders a component if the user is authenticated, otherwise redirects the user to the login page.
 * @param renderComponent The component to render if the user is authenticated
 * @param loader The component to render while TIDProvider is loading
 */
export const AuthenticationGuard: ParentComponent<AuthenticationGuardProps> = (
  props: AuthenticationGuardProps
) => {
  const authState = useAuth();

  createEffect(() => {
    if (!authState().isLoading && !authState().isAuthenticated) {
      authState()
        .loginWithRedirect()
        .catch((error: unknown) => {
          console.error('Error logging in', error);
        });
    }
  });

  return (
    <Show
      when={authState().isAuthenticated}
      fallback={<Show when={props.loader != undefined}>{props.loader}</Show>}
    >
      {props.children}
    </Show>
  );
};
